import { makeAutoObservable } from 'mobx'
import { showToast, Typography } from 'shared/ui'
import type { IEntitiesStore } from 'entities/EntitiesExport'

const FEATURE_KEY = 'hubspot-ticket-owner-auto-assign'
const DEFAULT_ASSIGN_TO = 'conversation_owner'

export class IntegrationHubspotSettingsTicketOwnerStore {
  constructor(private readonly _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get active() {
    return this._entities.userSettingsStore.isHubspotTicketOwnerAutoAssignActive
  }

  get assignTo() {
    return this._entities.userSettingsStore.hubspotTicketOwnerAssignTo
  }

  get options() {
    return [
      {
        id: DEFAULT_ASSIGN_TO,
        label: 'Conversation assignee',
        labelRight: (
          <Typography
            ariaLabel={'conversation_owner'}
            variant={'body-md-regular'}
            color={'var(--content-primary-tertiary)'}
          >
            The Salesmsg user handling the conversation
          </Typography>
        ),
      },
      {
        id: 'contact_owner',
        label: 'Contact owner',
        labelRight: (
          <Typography
            ariaLabel={'contact_owner'}
            variant={'body-md-regular'}
            color={'var(--content-primary-tertiary)'}
          >
            The HubSpot user who owns the matched contact
          </Typography>
        ),
      },
    ]
  }

  toggleActive = async () => {
    const value = !this.active

    const success = await this._entities.userSettingsStore.updateSettingsMultiple([
      { featureKey: FEATURE_KEY, settingsKey: 'active', value },
      {
        featureKey: FEATURE_KEY,
        settingsKey: 'assign_to',
        value: DEFAULT_ASSIGN_TO,
      },
    ])

    if (!success) {
      showToast({
        type: 'error',
        title: 'Something went wrong. Please try again.',
      })
      return
    }

    showToast({
      type: 'success',
      title: value ? 'Ticket owner turned on' : 'Ticket owner turned off',
      desc: value
        ? 'New tickets will be assigned automatically.'
        : 'New tickets will be unassigned.',
    })
  }

  setAssignTo = async (value: string) => {
    const success = await this._entities.userSettingsStore.updateSetting({
      featureKey: FEATURE_KEY,
      settingsKey: 'assign_to',
      value,
    })

    showToast({
      type: success ? 'success' : 'error',
      title: success
        ? 'Auto-assign ticket owner updated'
        : 'Something went wrong. Please try again.',
    })
  }
}
